'use client';

import { createContext } from 'react';

export const GlobalContext = createContext({
   signedUp: false,
   authToken: '',
   user: {},
   organisation: {},
   expandedSideNav: true
});